export default "__VITE_ASSET__d94c3d98__"